// @flow
import { styled } from 'mz-ui-kit'

export const FieldWrapper = styled('div', {
  width: '100%',
})

export const SelectField = styled('select', {
  border: 'none',
  bottom: 0,
  display: 'flex',
  left: 0,
  opacity: 0,
  position: 'absolute',
  right: 0,
  top: 0,
  zIndex: 10,
  width: '100%',
  WebkitAppearance: 'unset',
})
